import { Loader2, Play, Star, Library, RefreshCw } from "lucide-react";

export function GenerateBar({ label, generating, disabled, canSaveFavorite, onGenerate, onSaveFavorite }) {
  return (
    <section className="mt-10 flex flex-wrap items-center gap-5">
      <button
        data-testid="generate-btn"
        onClick={onGenerate}
        disabled={disabled}
        className="sp-play-btn h-16 w-16 rounded-full flex items-center justify-center shadow-2xl disabled:opacity-40 disabled:hover:scale-100"
        title="Générer"
      >
        {generating ? <Loader2 className="h-7 w-7 animate-spin" /> : <Play className="h-7 w-7 ml-1" fill="black" />}
      </button>
      <div>
        <div className="font-extrabold text-lg">{generating ? "Génération..." : "Générer ma playlist"}</div>
        <div className="text-sm text-[#B3B3B3]">{label}</div>
      </div>
      <button
        data-testid="save-favorite-btn"
        onClick={onSaveFavorite}
        disabled={!canSaveFavorite}
        className="ml-auto rounded-full border border-[#727272] hover:border-white px-4 py-2 text-sm font-bold flex items-center gap-2 disabled:opacity-40 transition-colors"
      >
        <Star className="h-4 w-4" /> Ajouter aux favoris
      </button>
    </section>
  );
}

export function SyncBanner({ syncing, onSync }) {
  return (
    <div className="mt-6 bg-[#FF2E93] text-black rounded-lg p-4 flex flex-wrap items-center gap-4">
      <Library className="h-6 w-6 shrink-0" />
      <div className="flex-1 min-w-[200px]">
        <div className="font-extrabold">Synchronise ta bibliothèque pour commencer</div>
        <div className="text-sm opacity-80">On scanne tes playlists perso + tes titres likés.</div>
      </div>
      <button
        data-testid="first-sync-btn"
        onClick={onSync}
        disabled={syncing}
        className="rounded-full bg-black text-white font-bold px-5 py-2.5 text-sm hover:scale-105 transition-transform flex items-center gap-2"
      >
        {syncing ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />}
        Synchroniser
      </button>
    </div>
  );
}
